import ApiClient from "@/domain/core/utils/apiClient";
import client_core from "@/services/clients/client_core";

const client = new ApiClient(client_core)

const endpoints = {
    admin_payout_list: '/dashboard/v2/admin/payouts/', // GET - all payouts across platform
    admin_payout_detail: '/dashboard/v2/admin/payouts/{id}/', // GET - specific payout details
    admin_mark_paid: '/dashboard/v2/admin/payouts/{id}/mark_paid/', // POST - mark payout as paid
    admin_download_excel: '/dashboard/v2/admin/payouts/{id}/download_excel/', // GET - download Excel for payout
    admin_delete_last_payout: '/dashboard/v2/admin/payouts/{id}/delete_last_payout/', // DELETE - delete last unpaid payout
}

export default {
    async fetchAdminPayoutList(filters, pagination, sorting) {
        let result = await client.get(endpoints.admin_payout_list, {
            ...filters,
            page_size: pagination.page_size ?? 20,
            page: pagination.page ?? 1,
            ordering: sorting.desc ? `-${sorting.column}` : sorting.column ?? '-created_at'
        })
        return {
            results: result.results,
            pagination: {
                num_pages: result.pagination.num_pages,
                page_size: result.pagination.page_size,
                page: result.pagination.page_number,
                total: result.pagination.total,
            }
        }
    },
    
    async fetchAdminPayoutDetail(id) {
        return await client.get(endpoints.admin_payout_detail.replace('{id}', id))
    },
    
    async markPayoutAsPaid(id, data = {}) {
        return await client.post(endpoints.admin_mark_paid.replace('{id}', id), data)
    },
    
    async downloadPayoutExcel(id) {
        return await client.download(endpoints.admin_download_excel.replace('{id}', id))
    },
    
    async deleteLastPayout(id) {
        return await client.delete(endpoints.admin_delete_last_payout.replace('{id}', id))
    }
}